/* tslint:disable */
/* eslint-disable */
/**
 * Brokers API
 * API for managing brokers
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetBrokerAddressDto } from './GetBrokerAddressDto';
import {
    GetBrokerAddressDtoFromJSON,
    GetBrokerAddressDtoFromJSONTyped,
    GetBrokerAddressDtoToJSON,
    GetBrokerAddressDtoToJSONTyped,
} from './GetBrokerAddressDto';

/**
 * Lecture d'un courtier au format de UpdateBrokerCommand (mêmes noms de champs), pour préremplir le formulaire d'édition. Les champs du compte de référence sont null si le cabinet n'en a pas.
 * @export
 * @interface GetBrokerResponse
 */
export interface GetBrokerResponse {
    /**
     * 
     * @type {string}
     * @memberof GetBrokerResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetBrokerResponse
     */
    personneMoraleId: string;
    /**
     * 
     * @type {string}
     * @memberof GetBrokerResponse
     */
    companyName?: string | null;
    /**
     * 
     * @type {GetBrokerAddressDto}
     * @memberof GetBrokerResponse
     */
    address?: GetBrokerAddressDto | null;
    /**
     * 
     * @type {string}
     * @memberof GetBrokerResponse
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetBrokerResponse
     */
    registrationNumber?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetBrokerResponse
     */
    capital: number;
    /**
     * 
     * @type {string}
     * @memberof GetBrokerResponse
     */
    rcsCity?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetBrokerResponse
     */
    rcsNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetBrokerResponse
     */
    oriasNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetBrokerResponse
     */
    rcp?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetBrokerResponse
     */
    complaintEmail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetBrokerResponse
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetBrokerResponse
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetBrokerResponse
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetBrokerResponse
     */
    username?: string | null;
    /**
     * Plateformes du compte de référence (celles que la mise à jour remplace).
     * @type {Array<string>}
     * @memberof GetBrokerResponse
     */
    plateformeIds: Array<string>;
}

/**
 * Check if a given object implements the GetBrokerResponse interface.
 */
export function instanceOfGetBrokerResponse(value: object): value is GetBrokerResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('personneMoraleId' in value) || value['personneMoraleId'] === undefined) return false;
    if (!('capital' in value) || value['capital'] === undefined) return false;
    if (!('plateformeIds' in value) || value['plateformeIds'] === undefined) return false;
    return true;
}

export function GetBrokerResponseFromJSON(json: any): GetBrokerResponse {
    return GetBrokerResponseFromJSONTyped(json, false);
}

export function GetBrokerResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBrokerResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'personneMoraleId': json['personneMoraleId'],
        'companyName': json['companyName'] == null ? undefined : json['companyName'],
        'address': json['address'] == null ? undefined : GetBrokerAddressDtoFromJSON(json['address']),
        'phone': json['phone'] == null ? undefined : json['phone'],
        'registrationNumber': json['registrationNumber'] == null ? undefined : json['registrationNumber'],
        'capital': json['capital'],
        'rcsCity': json['rcsCity'] == null ? undefined : json['rcsCity'],
        'rcsNumber': json['rcsNumber'] == null ? undefined : json['rcsNumber'],
        'oriasNumber': json['oriasNumber'] == null ? undefined : json['oriasNumber'],
        'rcp': json['rcp'] == null ? undefined : json['rcp'],
        'complaintEmail': json['complaintEmail'] == null ? undefined : json['complaintEmail'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'email': json['email'] == null ? undefined : json['email'],
        'username': json['username'] == null ? undefined : json['username'],
        'plateformeIds': json['plateformeIds'],
    };
}

export function GetBrokerResponseToJSON(json: any): GetBrokerResponse {
    return GetBrokerResponseToJSONTyped(json, false);
}

export function GetBrokerResponseToJSONTyped(value?: GetBrokerResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'personneMoraleId': value['personneMoraleId'],
        'companyName': value['companyName'],
        'address': GetBrokerAddressDtoToJSON(value['address']),
        'phone': value['phone'],
        'registrationNumber': value['registrationNumber'],
        'capital': value['capital'],
        'rcsCity': value['rcsCity'],
        'rcsNumber': value['rcsNumber'],
        'oriasNumber': value['oriasNumber'],
        'rcp': value['rcp'],
        'complaintEmail': value['complaintEmail'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'username': value['username'],
        'plateformeIds': value['plateformeIds'],
    };
}

